var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.storiesLength && _vm.isClientOwner && _vm.isProfilePage)?_c('section',{class:_vm.$style.section},_vm._l((_vm.stories),function(story){return _c('router-link',{key:story.id,attrs:{"to":_vm.Trans.i18nRoute({
        name: 'Stories',
        params: {
          id: story.id,
        },
      })}},[_c('v-avatar',{attrs:{"size":"md-2","src":_vm.appAvatarSrc(story.app),"srcset":_vm.appAvatarSrcset(story.app)}})],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }